var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle3, _circle4, _path10, _circle5, _path11, _path12, _path13, _circle6, _path14, _text, _text2, _path15, _path16, _circle7, _circle8, _circle9, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsOverthinking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 185 Q68 108 100 95 Q132 108 132 185 Q100 198 68 185 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 158 Q100 164 108 158",
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 80 L85 75 M110 70 L120 65 M90 60 L95 55",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 105 L55 100 M65 130 L55 128",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135 100 L145 95 M140 130 L150 125",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55 Q85 50 92 52",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115 50 Q120 55 125 52",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55 115 Q50 120 53 125",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268 185 Q268 108 300 95 Q332 108 332 185 Q300 198 268 185 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292 158 Q300 164 308 158",
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 65,
    r: 28,
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M285 42 L290 48 M315 42 L310 48",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M275 55 Q275 45 285 42",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325 55 Q325 45 315 42",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 65,
    r: 18,
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300 47 L300 50 M300 80 L300 83",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 225,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    opacity: 0.8
  }, "NOISE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 278,
    y: 225,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    opacity: 0.8
  }, "LOOP")), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175 130 L185 130 M175 135 L190 135 M178 140 L185 140",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210 130 Q215 125 220 130 Q215 135 210 130",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 70,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 70,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 60,
    r: 1,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 60,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 100,
    r: 2,
    fill: "#fafcfb",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsOverthinking);
export default __webpack_public_path__ + "static/media/vs-overthinking.6fbf9773b5861efbfb0d2c861b7032a3.svg";
export { ForwardRef as ReactComponent };